export default __webpack_public_path__ + "static/media/availableTable.b1747fe4.svg";